// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ISO 19115-1 Spatial schema codes for dataset spatial representation
 * @export
 */
export const SpatialSchemaCode = {
  Vector: "vector",
  Grid: "grid",
  Unknown: "unknown",
} as const;
export type SpatialSchemaCode = (typeof SpatialSchemaCode)[keyof typeof SpatialSchemaCode];

export function instanceOfSpatialSchemaCode(value: any): boolean {
  for (const key in SpatialSchemaCode) {
    if (Object.prototype.hasOwnProperty.call(SpatialSchemaCode, key)) {
      if (SpatialSchemaCode[key as keyof typeof SpatialSchemaCode] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SpatialSchemaCodeFromJSON(json: any): SpatialSchemaCode {
  return SpatialSchemaCodeFromJSONTyped(json, false);
}

export function SpatialSchemaCodeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SpatialSchemaCode {
  return json as SpatialSchemaCode;
}

export function SpatialSchemaCodeToJSON(value?: SpatialSchemaCode | null): any {
  return value as any;
}

export function SpatialSchemaCodeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): SpatialSchemaCode {
  return value as SpatialSchemaCode;
}
